<template>
  <div v-touch:swipe.right="close" class="screen">
    <transition name="fade">
      <Greets v-if="done" :name="name">
        <button class="back back-greets" @click="close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 512 512"
          >
            <polyline
              points="328 112 184 256 328 400"
              stroke="#000"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"
            />
          </svg>
        </button>
      </Greets>
    </transition>
    <div class="timer container">
      <button class="back" @click="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="512"
          height="512"
          viewBox="0 0 512 512"
        >
          <polyline
            points="328 112 184 256 328 400"
            stroke="#000"
            style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"
          />
        </svg>
      </button>
      <h1 class="name">{{ name }}</h1>
      <p class="date">{{ date }}</p>
      <div class="items">
        <div class="item">{{ days }} days</div>
        <div class="item">{{ hours }} hours</div>
        <div class="item">{{ minutes }} minutes</div>
        <div class="item">{{ seconds }} seconds</div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/index";
import Greets from "./Greets";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

export default {
  name: "Timer",
  store,
  components: {
    Greets
  },
  data() {
    return {
      item: store.state.currentItem,
      interval: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },
  methods: {
    tick() {
      let now = Date.now();
      let dest = Date.parse(this.date);
      let difference = dest - now;

      this.days = Math.floor(difference / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((difference % (1000 * 60)) / 1000);

      this.clearIfDone();
    },
    clearIfDone() {
      if (
        this.days < 0 &&
        this.hours < 0 &&
        this.minutes < 0 &&
        this.seconds < 0
      ) {
        store.commit("setDone"); // set done in current item (in store)
        clearInterval(this.interval); // stop counting
        store.commit("remove", {
          index: store.state.currentItem.index
        });
      }
    },
    close() {
      store.commit("close");
    }
  },
  computed: {
    name() {
      return this.item.name;
    },
    date() {
      return this.item.date;
    },
    done() {
      return this.item.done;
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.tick();
    }, 1000);
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: var(--smooth-slow);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.timer {
  position: relative;
}

.name,
.date {
  text-align: center;
}

.name {
  margin-top: 0;
}

.date {
  padding-bottom: var(--gutter);
  color: rgb(var(--text-2));
}

.back {
  background: none;
  border: none;
  transition: var(--smooth-fast);
  margin-top: var(--gutter);
}

.back:hover {
  opacity: 0.6;
}

.back svg {
  width: 1.6rem;
  height: 1.6rem;
}

.back svg polyline {
  stroke: rgb(var(--accent));
}

.items {
  display: flex;
  flex-wrap: wrap;
}

.item {
  text-align: center;
  flex-grow: 1;
  word-break: break-all;
  flex-wrap: wrap;
  background: rgb(var(--gray-2));
  color: rgb(var(--accent));
  padding: calc(var(--gutter) / 2) var(--gutter);
  border-radius: var(--brs);
  transition: var(--smooth-fast);
}

.item:not(:last-child) {
  margin-right: var(--gutter);
}

.item:hover {
  background: rgb(var(--gray-3));
}

@media (max-width: 576px) {
  .items {
    flex-direction: column;
  }

  .item:not(:last-child) {
    margin-right: unset;
    margin-bottom: var(--gutter);
  }
}
</style>
